import styled from '@emotion/styled';
import { IconButton, DialogTitle } from '@mui/material';

export const StyledIconButton = styled(IconButton)`
  position: absolute;
  right: 8px;
  top: 8px;
`;

export const StyledDialogTitle = styled(DialogTitle)`
  padding-right: 40px;
`;
